import {
    INFOCUSEITEMS_REQUEST,
    INFOCUSEITEMS_SUCCESS,
    INFOCUSEITEMS_FAILURE,
    FAQ_ITEMS_FAILURE,
    FAQ_ITEMS_SUCCESS,
    FAQ_ITEMS_REQUEST,
    ABOUT_US_FAILURE,
    ABOUT_US_SUCCESS,
    ABOUT_US_REQUEST,
    THEMECOLOR_DARK,
    THEMECOLOR_LIGHT,
} from "../constants/ActionTypes";

const initialState = {
    loading: true,
    infocusPages: [],
    collections: [],
    influences: [],
    error: null,
    faqLoading: true,
    faqError: null,
    faqContent: null,
    aboutLoading: true,
    aboutError: null,
    aboutContent: null,
    themeColor : '',
};

export default function landingReducer(state = initialState, action) {
    switch (action.type) {
        case INFOCUSEITEMS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case INFOCUSEITEMS_SUCCESS:
            return {
                ...state,
                // always replacing data
                infocusPages: action.data.infocus_pages,
                collections: action.data.infocus_collection_pages,
                influences: action.data.infocus_influencer_pages,
                page_layout: action.data.layout_details,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case INFOCUSEITEMS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case FAQ_ITEMS_REQUEST:
            return {
                ...state,
                faqLoading: true,
            };
        case FAQ_ITEMS_SUCCESS:
            return {
                ...state,
                faqContent: action.data.static_footer_content,
                faqLoading: false,
            };
        case FAQ_ITEMS_FAILURE:
            return {
                ...state,
                faqLoading: false,
                faqError: action.error,
            };
            case ABOUT_US_REQUEST:
            return {
                ...state,
                aboutLoading: true,
            };
        case ABOUT_US_SUCCESS:
            return {
                ...state,
                aboutContent: action.data.static_footer_content.AboutUs,
                aboutLoading: false,
            };
        case ABOUT_US_FAILURE:
            return {
                ...state,
                aboutLoading: false,
                aboutError: action.error,
            };
        case THEMECOLOR_DARK:
            return{
                ...state,
                themeColor: 'Dark',
            };
        case THEMECOLOR_LIGHT:
            return{
                ...state,
                themeColor: 'Light'
            }
        default:
            return state;
    }
}
